import { ValidatorConstraint, ValidatorConstraintInterface } from 'class-validator';

/**
 * Custom validator for number range format field.
 * Ensures that the format contains 15 or fewer '#' symbols.
 */
@ValidatorConstraint({ name: 'NumberRangeFormatValidator', async: false })
export class NumberRangeFormatValidator implements ValidatorConstraintInterface {
  validate(value: string): boolean {
    return typeof value === 'string' && (value.match(/#/g) || []).length <= 15;
  }

  defaultMessage(): string {
    return 'validations:error.formatTooManyHashSymbols';
  }
}
